export const EXSBITEMTYPE_DELETE_RESET = 'EXSBITEMTYPE_DELETE_RESET'
export const EXSBITEMTYPE_DELETE_SET_ERROR = 'EXSBITEMTYPE_DELETE_SET_ERROR'
export const EXSBITEMTYPE_DELETE_SET_DELETED = 'EXSBITEMTYPE_DELETE_SET_DELETED'
export const EXSBITEMTYPE_DELETE_TOGGLE_LOADING = 'EXSBITEMTYPE_DELETE_TOGGLE_LOADING'
